 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import DEDICATION from '@/components/dedication'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import FOREWORD from '@/components/foreword'
 import PREFACE from '@/components/preface'
 import PART001 from '@/components/part001'
 import PART001HELPWANTEDPARTTIMEWORKFULLTIMEHOURS from '@/components/part001helpwantedparttimeworkfulltimehours'
 import PART001CHAPTER001 from '@/components/part001chapter001'
 import PART001CHAPTER002 from '@/components/part001chapter002'
 import PART001CHAPTER003 from '@/components/part001chapter003'
 import PART001CHAPTER004 from '@/components/part001chapter004'
 import PART001CHAPTER005 from '@/components/part001chapter005'
 import PART001CHAPTER006 from '@/components/part001chapter006'
 import PART001CHAPTER007 from '@/components/part001chapter007'
 import PART001CHAPTER008 from '@/components/part001chapter008'
 import PART001CHAPTER009 from '@/components/part001chapter009'
 import PART001CHAPTER010 from '@/components/part001chapter010'
 import PART001CHAPTER011 from '@/components/part001chapter011'
 import PART001REFS from '@/components/part001refs'
 import PART002 from '@/components/part002'
 import PART002CHAPTER012 from '@/components/part002chapter012'
 import PART002CHAPTER013 from '@/components/part002chapter013'
 import PART002CHAPTER014 from '@/components/part002chapter014'
 import PART002CHAPTER015 from '@/components/part002chapter015'
 import PART003 from '@/components/part003'
 import PART003CHAPTER016 from '@/components/part003chapter016'
 import PART003CHAPTER017 from '@/components/part003chapter017'
 import PART003CHAPTER018 from '@/components/part003chapter018'
 import PART003CHAPTER019 from '@/components/part003chapter019'
 import PART003CHAPTER020 from '@/components/part003chapter020'
 import PART003CHAPTER021 from '@/components/part003chapter021'
 import PART003CHAPTER022 from '@/components/part003chapter022'
 import NOTES from '@/components/notes'
 import ALSOBYRICHARDLISTER from '@/components/alsobyrichardlister'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/acknowledgments",
 			"name" : "acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/part001",
 			"name" : "part001",
 			"component" : PART001
 		},
 		{
 			"path" : "/part001helpwantedparttimeworkfulltimehours",
 			"name" : "part001helpwantedparttimeworkfulltimehours",
 			"component" : PART001HELPWANTEDPARTTIMEWORKFULLTIMEHOURS
 		},
 		{
 			"path" : "/part001chapter001",
 			"name" : "part001chapter001",
 			"component" : PART001CHAPTER001
 		},
 		{
 			"path" : "/part001chapter002",
 			"name" : "part001chapter002",
 			"component" : PART001CHAPTER002
 		},
 		{
 			"path" : "/part001chapter003",
 			"name" : "part001chapter003",
 			"component" : PART001CHAPTER003
 		},
 		{
 			"path" : "/part001chapter004",
 			"name" : "part001chapter004",
 			"component" : PART001CHAPTER004
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js